module.exports = __webpack_public_path__ + "static/pullquote-15d3df4aaaf8dc0f97ed96eb487151af.svg";